import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Powered by IPINPA"
      links={[
        {
          key: 'IPINPA',
          title: 'IPINPA',
          href: 'https://ipinpa.com',
          blankTarget: true,
        }
      ]}
    />
  );
};

export default Footer;
